import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, ArrowRight } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';

const CIRCULAR_IMAGE = 'https://static.prod-images.emergentagent.com/jobs/af49a006-9be0-463b-96a6-a9914972e5ea/images/35f4903f3dc96decd6a830e95e2230b83e455cff0035b55c1dc7b4b6dfeed63d.jpeg';

export default function ClubPage() {
  const { t } = useLang();

  const discountScale = [
    { year: { it: '1° anno', en: 'Year 1' }, discount: '20%' },
    { year: { it: '2° anno', en: 'Year 2' }, discount: '30%' },
    { year: { it: '3° anno', en: 'Year 3' }, discount: '40%' },
    { year: { it: '4° anno', en: 'Year 4' }, discount: '50%' },
    { year: { it: '5° anno', en: 'Year 5' }, discount: '60%' },
    { year: { it: '6° anno', en: 'Year 6' }, discount: '70%' },
    { year: { it: '7° anno', en: 'Year 7' }, discount: '80%' },
    { year: { it: '8° anno', en: 'Year 8' }, discount: '90%' },
    { year: { it: '9° anno', en: 'Year 9' }, discount: { it: 'GRATIS', en: 'FREE' } },
  ];

  return (
    <div data-testid="club-page" className="min-h-screen bg-[#FAF9F6] pt-24">
      {/* Hero */}
      <section className="px-6 md:px-12 lg:px-24 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Crown className="w-6 h-6 text-[#4A5D23]" />
              <p className="overline">Club Biolosophy</p>
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-[#1C1917] mb-8">
              "Biolosophy Value"
            </h1>
            <p className="text-lg text-[#1C1917]/80 leading-relaxed mb-6">
              {t({
                it: 'Unisciti a noi, registra il tuo acquisto e accedi ai vantaggi:',
                en: 'Join us, register your purchase and unlock the benefits:',
              })}
            </p>
            <p className="text-lg text-[#1C1917]/70 leading-relaxed mb-6">
              {t({
                it: "Riportando il tuo capo entro il primo anno avrai lo sconto del 20% sul tuo nuovo acquisto, il secondo anno lo sconto del 30%, il terzo del 40%, il quarto del 50%, il quinto del 60%, il sesto anno del 70%, il settimo anno lo sconto sarà dell'80%, l'ottavo anno del 90% e al nono anno, se ci riporti il tuo capo, ne riceverai uno totalmente gratuito di pari valore.",
                en: "Bring back your garment within the first year and get a 20% discount on your new purchase, 30% in the second year, 40% in the third, 50% in the fourth, 60% in the fifth, 70% in the sixth year, 80% in the seventh, 90% in the eighth — and in the ninth year, if you bring back your garment, you will receive a brand new one of equal value completely free.",
              })}
            </p>
            <p className="text-sm text-[#57534E] mb-10">
              {t({
                it: "Lo sconto si applica dopo l'approvazione del reso.",
                en: 'The discount is applied after the return has been approved.',
              })}
            </p>
            <Link
              to="/register"
              data-testid="club-join-btn"
              className="btn-primary inline-flex items-center gap-2"
            >
              {t({ it: 'Unisciti al Club', en: 'Join the Club' })}
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
          <div className="hidden lg:block">
            <img
              src={CIRCULAR_IMAGE}
              alt="Biolosophy Value"
              className="w-full aspect-[4/5] object-cover"
            />
          </div>
        </div>
      </section>

      {/* Discount Scale */}
      <section className="px-6 md:px-12 lg:px-24 pb-24">
        <div className="grid grid-cols-3 md:grid-cols-9 gap-3" data-testid="club-discount-scale">
          {discountScale.map((step) => {
            const isFree = typeof step.discount !== 'string';
            return (
              <div
                key={step.year.it}
                className={`text-center py-6 px-2 ${
                  isFree ? 'bg-[#4A5D23] text-white' : 'bg-white border border-[#E5E0D8]'
                }`}
              >
                <div className={`text-2xl font-light mb-1 ${isFree ? 'text-white' : 'text-[#4A5D23]'}`}>
                  {isFree ? t(step.discount) : step.discount}
                </div>
                <div className={`text-xs uppercase tracking-wider ${isFree ? 'text-white/80' : 'text-[#57534E]'}`}>
                  {t(step.year)}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
